module.exports = __webpack_public_path__ + "img/long-neck-1.b1ea1d4e.png";